import { Container, Flex, Paper, Text, Box, Button } from "@mantine/core";
import { IconArrowRight, IconCircleCheck, IconUsers } from "@tabler/icons-react";
import { squareIcon } from "./PricingStyles";
import { useNavigate } from "react-router-dom";
import { CollaborationPrice } from "@/components/shared/constants/general.const";

export default function PricingCardsSection() {
  const navigate = useNavigate();

  return (
    <Box
      py="xl"
      style={{
        background: "linear-gradient(to bottom, #FFFFFF, #F1F7FF)",
      }}
    >
      <Container size="md">
        <Flex gap="xl" justify="center" align="stretch" direction={{ base: "column", sm: "row" }}>
          {/* Free Plan */}
          <Paper
            p="xl"
            radius="lg"
            w={{ base: "100%", sm: 280 }}
            style={{
              border: "2px solid #E5E7EB",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <IconCircleCheck size={20} color="#2B8A3E" style={squareIcon("#D3F9D8")} />

            <Text size="lg" fw={600} mb="md">
              Free Discovery
            </Text>
            <Text size="xs" mb="lg">
              Everything you need to for try out a business
            </Text>

            <Flex align="baseline" gap="xs" mb="xl">
              <Text size="42px" fw={700}>
                $0
              </Text>
              <Text>/ month</Text>
            </Flex>

            <Box style={{ flex: 1 }}>
              {[
                "Unlimited outreach (browsing)",
                "Advanced search and filters",
                "Anonymous profile viewing",
                "Detailed company info",
                "User verification badges",
                "10 express profile reminders",
              ].map((item) => (
                <Flex key={item} gap="sm" align="center" mb="sm">
                  <IconCircleCheck size={16} color="#51CF66" stroke={2.5} style={{ flexShrink: 0 }} />
                  <Text size="xs" style={{ whiteSpace: "nowrap" }}>
                    {item}
                  </Text>
                </Flex>
              ))}
            </Box>

            <Button variant="outline" color="#0F172A" fullWidth mt="md" onClick={() => navigate("/signup")}>
              Sign Up Free
            </Button>
          </Paper>

          {/* Paid Plan */}
          <Paper
            p="xl"
            radius="lg"
            w={{ base: "100%", sm: 280 }}
            style={{
              border: "2px solid #2563EB",
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              bg="#2563EB"
              px="xs"
              py="xs"
              style={{
                position: "absolute",
                top: -12,
                left: "50%",
                transform: "translateX(-50%)",
                borderRadius: 16,
              }}
            >
              <Text size="10px" fw={600} c="white" style={{ whiteSpace: "nowrap" }}>
                Pay When You Connect
              </Text>
            </Box>

            <IconUsers size={20} color="#2563EB" style={squareIcon("#E7F5FF")} />

            <Text size="lg" fw={600} mb="md">
              Collaboration Workspace
            </Text>
            <Text size="xs" mb="lg">
              Suitable when you work with 3-5 workspace
            </Text>

            <Flex align="baseline" gap="xs" mb="xs">
              <Text size="42px" fw={700}>
                {CollaborationPrice}
              </Text>
              <Text>/ month</Text>
            </Flex>
            <Text size="xs" mb="lg">
              Complete payment. And fully collaborate.
            </Text>

            <Box style={{ flex: 1 }}>
              {[
                "Everything in Free Discovery",
                "Full company details revealed",
                "Direct contact information",
                "Profile access workspace",
                "Auto-advanced API",
                "Secured document sharing",
                "Protected messaging",
                "Priority both & swift trust",
                "Collaboration invitation",
              ].map((item) => (
                <Flex key={item} gap="sm" align="center" mb="sm">
                  <IconCircleCheck size={16} color="#2563EB" stroke={2.5} style={{ flexShrink: 0 }} />
                  <Text
                    size="xs"
                    fw={item === "Everything in Free Discovery" ? 400 : 400}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {item}
                  </Text>
                </Flex>
              ))}
            </Box>

            <Button fullWidth>Get Started</Button>
          </Paper>
        </Flex>

        <Flex direction="column" align="center" gap="xs" mt="xl">
          <Text size="xs" ta="center">
            Does it needfor collaboration with small contact Industry?
          </Text>
          <Text
            size="xs"
            c="#2563EB"
            fw={600}
            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }}
          >
            Contact Sales for Enterprise Pricing
            <IconArrowRight size={14} />
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}
